import { useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { MediaQueryContext } from '../../../contexts/mediaQueryContext';
import Markup from '../../Markup';
import Typography from '../../Typography';
import usePlayerCaptions from './hooks/usePlayerCaptions';
import useStyles from './playerCaptions.styles';

const PlayerCaptions = ({ active, muted, playerRef, tracks, trackIndex }) => {
  const { isDesktop } = useContext(MediaQueryContext);
  const { caption } = usePlayerCaptions(playerRef, muted, tracks, trackIndex);
  const styles = useStyles();

  return (
    <Typography
      className={clsx(styles.wrapper, active && styles.active)}
      variant={`videoCaption${isDesktop ? '' : 'Mobile'}`}
      withShadow
    >
      <Markup content={caption} />
    </Typography>
  );
};

PlayerCaptions.propTypes = {
  active: PropTypes.bool.isRequired,
  muted: PropTypes.bool.isRequired,
  playerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  tracks: PropTypes.any,
  trackIndex: PropTypes.number,
};

PlayerCaptions.defaultProps = {
  playerRef: null,
  tracks: undefined,
  trackIndex: 0,
};

export default PlayerCaptions;
